export default {
    maxChildrenPerPage: 20
};
